// react and mui stuff
import Markdown from "markdown-to-jsx";

import Sheet from "@mui/joy/Sheet"
import Table from "@mui/joy/Table"
import Typography from "@mui/joy/Typography"

// custom components
import UserCard from "../usercard";
import PurposeHelper from "./purposeHelper";

// data and stuff
import { BaseUserProfile, CliUser } from "../../types/users";

type props = {
  profile: BaseUserProfile | CliUser
  setProfile: Function
}

export default function Mod ({profile, setProfile}: props) {
  const show = profile.infractions && profile.infractions.detail.length > 0;
  return (
    <div style={{ display: "inline-block", overflowX: "auto" }}>
      <div style={{position: "sticky", left: 0}}>
        <PurposeHelper helpText="View past infractions of the Code of Conduct"/>
        {show && <Typography level="body-lg">{profile.infractionCount} infraction(s) in the last {profile.infractions?.time} days</Typography>}
      </div>
        {show && 
          <Sheet variant="soft" sx={{ pt: 1, borderRadius: 'sm', width: "100%", minWidth: "600px", overflowX: "auto" }}>
            <Table
              borderAxis="bothBetween"
              stickyHeader
              stripe="odd"
              hoverRow
              sx={{width: "100%", minWidth: "600px" }}
            >
              <thead>
                <tr>
                  <th style={{width: "75px"}}>Value</th>
                  <th style={{width: "80px"}}>Date</th>
                  <th>Description</th>
                  <th>Mod</th>
                </tr>
              </thead>
              <tbody>
                {
                  profile.infractions?.detail.map((inf, i) => {
                    return (
                      <tr key={i}>
                        <td>{inf.value}</td>
                        <td>{inf.timestamp}</td>
                        <td style={{whiteSpace: "normal"}}><Markdown children={inf.description || "Unknown"}/></td>
                        <td><UserCard profile={inf.mod} setProfile={setProfile} loading={false}/></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </Sheet>
        }
        {!show && <>Looks like {profile.displayName} has a clean record!</>}
    </div>
  )
}